<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="contact" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "contact-view-logs",

  components: { LogListTable },

  props: ["contact"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
